// file with constants for the entire proyect

//filters extra data ids
export const DOES_NOT_EXIST = -9000;
export const NOT_COMPATIBLE_SCHEDULES = -9001;
export const SCHEDULE_HASH = -9002;

//filters
export const BUILDINGS_CHECKLIST = 1;
export const CLASSROOM_CHECKLIST = 2;
export const DATE_RANGE_SELECT = 3;
export const DAY_PERIOD_SELECT = 4;
export const PARAMETERS_CHECKLIST = 5;
export const BUILDING_SELECT = 6;
export const DAY_SELECT = 7;
export const MONTH_RANGE_SELECT = 8;
export const MONTH_SELECT = 9;
export const PERIOD_CHECKLIST = 10;	
export const SPACE_TIME_SELECTOR = 11;
export const SCHEDULE_SELECTOR = 12;
export const DAYS_OF_WEEK_FILTER = 13;